import React from 'react';
import { cn } from '@/utils/cn.ts';

export interface NotificationBadgeProps {
    /** Number to display. If 0, badge is hidden. If > 99, shows "99+" */
    count?: number;
    /** Variant style */
    variant?: 'dot' | 'number';
    /** Additional classes */
    className?: string;
    /** Max number to display before showing "+" */
    max?: number;
}

/**
 * NotificationBadge component for unread count indicators
 * Used primarily on sidebar icons to show unread counts
 * Positioned absolutely, expects parent to have relative positioning
 */
export const NotificationBadge: React.FC<NotificationBadgeProps> = ({
    count = 0,
    variant = 'number',
    className = '',
    max = 99,
}) => {
    if (count === 0) return null;

    const displayValue = count > max ? `${max}+` : count.toString();

    if (variant === 'dot') {
        return (
            <span
                aria-hidden="true"
                className={cn(
                    'absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white dark:ring-surface-dark',
                    className
                )}
            />
        );
    }

    return (
        <span
            className={cn(
                'absolute -top-1 -right-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-500 px-1 font-bold text-[10px] text-white ring-2 ring-white dark:ring-surface-dark',
                className
            )}
        >
            {displayValue}
        </span>
    );
};













